export default (object, fieldPath, value) => {
  const parts = fieldPath.split('.');
  let current = object;
  for (var i = 0; i < parts.length; i++) {
    if (i < parts.length - 1) {
      current[parts[i]] = current[parts[i]] || {};
    } else {
      current[parts[i]] = value;
    }
    current = current[parts[i]];
  }
};